// extracted by mini-css-extract-plugin
export default {"container":"Help_container__E0Z-n","tabs":"Help_tabs__6MOWa","content":"Help_content__E+F-V"};